import { getDefaultKeyBinding, RichUtils } from 'draft-js';
import { useCallback } from 'react';

var useHandleKeyBindingFnCallback = function useHandleKeyBindingFnCallback(editorState, setEditorState) {
  return useCallback(function (event) {
    if (event.keyCode === 9
    /* TAB */
    ) {
      var newEditorState = RichUtils.onTab(event, editorState, 4
      /* maxDepth */
      );

      if (newEditorState !== editorState) {
        setEditorState(newEditorState);
      }

      return null;
    }

    return getDefaultKeyBinding(event);
  }, [editorState, setEditorState]);
};

export default useHandleKeyBindingFnCallback;